import { render, staticRenderFns } from "./obituarySp.vue?vue&type=template&id=711fc3c4&scoped=true&"
import script from "./obituarySp.vue?vue&type=script&lang=js&"
export * from "./obituarySp.vue?vue&type=script&lang=js&"
import style0 from "./obituarySp.vue?vue&type=style&index=0&id=711fc3c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711fc3c4",
  null
  
)

export default component.exports